import { render, staticRenderFns } from "./PatientSummary.vue?vue&type=template&id=efe4d700"
import script from "./PatientSummary.vue?vue&type=script&lang=js"
export * from "./PatientSummary.vue?vue&type=script&lang=js"
import style0 from "./PatientSummary.vue?vue&type=style&index=0&id=efe4d700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports